import type { SpaceMode } from "../../shared/schema";
import type { IconName } from "../assets/icons";

const tooltipByMode: Partial<Record<SpaceMode, string>> = {
  personal: "Personal workflows",
  private: "Private space",
};

export function spaceIcon(mode: SpaceMode): IconName {
  if (mode === "personal") return "circle-user-round";
  return "hash";
}

export function spaceIconTooltip(mode: SpaceMode): string | undefined {
  return tooltipByMode[mode];
}
